import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

import { AuthApiError, forgotPassword } from "../../services/authApi";
import { getApiBase } from "../../services/apiConfig";
import "../../Components/admin/adminLogin.css";

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      if (!getApiBase()) {
        setError("API base URL is disabled. Set REACT_APP_API_BASE or restore the default.");
        return;
      }
      await forgotPassword(email.trim());
      setDone(true);
    } catch (err) {
      const msg = err instanceof AuthApiError ? err.message : err?.message || "Something went wrong.";
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="adminLoginPage">
      <div className="adminLoginCard" role="dialog" aria-label="Forgot password">
        <div className="adminLoginTop">
          <Link className="adminLoginBackHome" to="/admin/login">
            <span className="adminLoginBackHomeIcon" aria-hidden="true">
              <FaArrowLeft />
            </span>
            Back to sign in
          </Link>
          <h1 className="adminLoginTitle">Forgot password</h1>
          <p className="adminLoginSubtitle">Enter your email. If an account exists, you will receive reset instructions.</p>
        </div>

        {done ? (
          <div className="adminLoginForm" style={{ paddingTop: 0 }}>
            <div className="adminLoginFormError" style={{ color: "#047857", background: "rgba(16, 185, 129, 0.1)", borderColor: "rgba(16, 185, 129, 0.28)" }}>
              Check your email for the next steps.
            </div>
            <Link className="adminLoginButton" to="/admin/login" style={{ textAlign: "center", textDecoration: "none", display: "block" }}>
              Return to sign in
            </Link>
          </div>
        ) : (
          <form className="adminLoginForm" onSubmit={onSubmit}>
            {error ? (
              <div className="adminLoginFormError" role="alert">
                {error}
              </div>
            ) : null}
            <label className="adminLoginLabel" htmlFor="forgotEmail">
              Email
            </label>
            <div className="adminLoginField">
              <input
                id="forgotEmail"
                className="adminLoginInput"
                style={{ width: "100%" }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                autoComplete="email"
                required
              />
            </div>
            <button className="adminLoginButton" type="submit" disabled={submitting}>
              {submitting ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
